import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getUserToken } from './Common'

const BgcPrivateRoute = () => {
    const isLoggedIn = getUserToken()

    if (!isLoggedIn) {
        return <Navigate to="/bgc/login" replace />
    }

    return <Outlet />
}

export default BgcPrivateRoute